import React, { useState, useEffect } from 'react';
import useProtecaoDeRota from '../hooks/useProtecaoDeRota';
import { Spin, Card, Typography, Tag, Space, Descriptions, message } from 'antd';
import SplitMainLayout from '../layouts/SplitMainLayout';
import ListaDashboardsGrupo from '../componentes/ListaDashboardsGrupo';
import { useParams } from 'react-router-dom';
import useApi from '../hooks/useApi';
import ListaUsuariosGrupo from '../componentes/ListaUsuariosGrupo';

const { Title } = Typography;

const PaginaViewGrupo = () => {
  const verificando = useProtecaoDeRota();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);

  const { callApi } = useApi(`https://vision.alfama.com/api/view/grupos_permissao/${id}`, { 
    includeToken: true,
  });

  useEffect(() => {
    const buscarDadosGrupo = async () => {
      try {
        setLoading(true);
        const dados = await callApi();
        setResponse(dados);
      } catch (error) {
        console.error('Erro ao buscar dados do grupo:', error);
        message.error('Erro ao carregar dados do grupo');
      } finally {
        setLoading(false);
      }
    };

    buscarDadosGrupo();
  }, [id, callApi]);

  if (verificando || loading) {
    return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', marginTop: '10%' }} />;
  }

  const leftContent = (
    <Card className="h-full">
      <Space direction="vertical" size="large" style={{ width: '100%', marginTop: '-300px' }}>
        <Title level={4}>Detalhes</Title>
        
        <Descriptions bordered column={1}>
          <Descriptions.Item label="ID">
            {id}
          </Descriptions.Item>
          <Descriptions.Item label="Nome">
            {response?.nome_grupo}
          </Descriptions.Item>
          
          <Descriptions.Item label="Código">
            {response?.codigo_grupo}
          </Descriptions.Item>
          <Descriptions.Item label="Situação">
            <Tag color={response?.situacao_grupo === 'ativo' ? 'green' : 'red'}>
              {response?.situacao_grupo?.toUpperCase()}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Criado Em ">
            {response?.grupo_data_criacao || 'Sem descrição'}
          </Descriptions.Item>
          <Descriptions.Item label="Atualizado Em ">
            {response?.grupo_data_atualizacao || 'Sem descrição'}
          </Descriptions.Item>
          <Descriptions.Item label="Descrição">
            {response?.descricao_grupo || 'Sem descrição'}
          </Descriptions.Item>
        </Descriptions>
      </Space>
    </Card>
  );
  const tabItems = [
    {
      key: '1',
      label: 'Dashboards',
      children: <ListaDashboardsGrupo idGrupo={id} />
    },
    {
      key: '2',
      label: 'Usuários',
      children: <ListaUsuariosGrupo idGrupo={id} />
    }
  ];

  return (
    <SplitMainLayout
      leftContent={leftContent}
      tabItems={tabItems}
    />
  );
};

export default PaginaViewGrupo;